import "./css/games.css";
import CustomSvg from "../svgs/CustomSvg";
import { IoArrowBackSharp } from "react-icons/io5";
import { useContext, useEffect, useRef, useState } from "react";
import JoinLobbyModal from "./auxiliary/JoinLobbyModal";
import DashboardHeader from "../dashboard/DashboardHeader/DashboardHeader";
import ActiveUsers from "./ActiveUsers";
import AmountPicker from "../payments/auxiliary/AmountPicker";
import CollapseBlock from "../dashboard/CollapseBlockLeft/collapseblockleft";
import CollapseBlockRight from "../dashboard/collapseblockright/collapseblockright";
import { useNavigate, useParams } from "react-router-dom";
import { useGames, useUser } from "../../utils/hooks";
import { postRequest } from "../apiRequests/requestApi";
import CustomErrorMsg from "../errorMsg/CustomErrorMsg";
import socket from "../../socket";
import { GamesContext } from "../../utils/contexts/GameContext";
import { UserContext } from "../../utils/contexts/UserContext";
import ShareInvite from "./ShareInvite";
import JoinGame from "./JoinGame";
import ActivePlayers from "./ActivePlayer";
import { CSSTransition } from "react-transition-group";
import { allGames } from "../games/auxiliary/gamesAux";

export default function SelectedGame() {
  const navigate = useNavigate();
  const navigateTo = (path) => navigate(path);
  const goToTournaments = ({ user_id, stakeValue, roomID }) =>
    navigateTo(
      `/tournaments/play/${user_id}/${gameId}/${stakeValue}/${roomID}`
    );
  const goToAllGames = () => navigateTo("/games");

  const { setLobbyCode, setGameId } = useGames();
  const { setUserDetails, user } = useUser();

  const gameContextData = useContext(GamesContext);
  const userContextData = useContext(UserContext);

  const params = useParams();
  const { gameId } = params;

  const { games, getGames } = useGames();

  const stakesNodeRef = useRef(null);
  const showActiveUsersNodeRef = useRef(null);
  const showActivePlayersNodeRef = useRef(null);

  const [selectedGame, setSelectedGame] = useState();
  const [roomId, setRoomId] = useState();
  const [apiReqs, setApiReqs] = useState({ isLoading: false, errorMsg: null });
  const [showGames, setShowGames] = useState(true);
  const [showActiveUsers, setShowActiveUsers] = useState(false);
  const [showActivePlayers, setShowActivePlayers] = useState(false);
  // const [stakeForActivePlayers, setStakeForActivePlayers] = useState(null);
  const [showBtns, setShowBtns] = useState(true);
  const [showStakes, setShowStakes] = useState(false);
  const [stakeValue, setStakeValue] = useState();
  const [joinLobbyModal, setJoinLobbyModal] = useState({
    visible: false,
    onHide: null,
    size: "md",
  });

  const [value, setValue] = useState(100);
  const [isLeftBlockOpen, setIsLeftBlockOpen] = useState(true);
  const [isRightBlockOpen, setIsRightBlockOpen] = useState(true);
  const [blocksOpen, setBlocksOpen] = useState("both");
  const [isMobile, setIsMobile] = useState(false);
  const [isDesktop, setIsDesktop] = useState(true);

  const [showShareInvite, setShowShareInvite] = useState(false);
  const [lobbyData, setLobbyData] = useState(null);
  const [showJoinGame, setShowJoinGame] = useState(false);
  const [loadingGame, setLoadingGame] = useState(true);

  useEffect(() => {
    const get = async () => {
      try {
        await getGames(); // assumed to update `games` from context or global state
      } catch (error) {
        // console.error(error);
      }
    };
    get();
  }, []);

  useEffect(() => {
    if (!Array.isArray(games) || games.length === 0) return;

    const s_game = games.find((game) => String(game.id) === String(gameId));
// console.log("Selected game:", s_game);
    if (s_game) {
      setSelectedGame(s_game);
      setLoadingGame(false);
    } else {
      navigate("/games"); // invalid ID — redirect
    }
  }, [games, gameId, navigate]);

  useEffect(() => {

    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isLeftBlockOpen && isRightBlockOpen) {
      setBlocksOpen("both");
    }

    if (!isLeftBlockOpen && !isRightBlockOpen) {
      setBlocksOpen("none");
    }

    if (
      (!isLeftBlockOpen && isRightBlockOpen) ||
      (isLeftBlockOpen && !isRightBlockOpen)
    ) {
      setBlocksOpen("one");
    }
  }, [isLeftBlockOpen, isRightBlockOpen]);

  useEffect(() => {
    if (apiReqs.isLoading) {
      createLobby();
    }
  }, [apiReqs]);

  // useEffect(() => {
  //   if (games) {
  //     const s_game = games.filter((game) => game.id === gameId);
  //     console.log(s_game)
  //     if (s_game[0]) {
  //       setSelectedGame(s_game[0]);
  //     } else {
  //       goToAllGames();
  //     }
  //   } else {
  //     goToAllGames();
  //   }
  // }, [games[0]]);

  const initiateLobbyCreation = () =>
    setApiReqs({ isLoading: true, errorMsg: null });

  const createLobby = async () => {
    const selectedGameArr = games?.filter((game) => String(game.id) === String(gameId));
    if (!selectedGameArr || !selectedGameArr[0]) {
      setApiReqs({
        isLoading: false,
        errorMsg: `Game not found for id: ${gameId}. Check if the game exists in the games array.`
      });
      return;
    }
    const { _id } = selectedGameArr[0];

    const details = {
      gameId: _id,
      wagerAmount: value * 100,
    };

    try {
      const response = await postRequest({
        url: "/create-lobby",
        data: details,
      });
      const newUser = {
        ...user,
        walletBalance: user.walletBalance - value * 100,
      };

      setUserDetails(newUser);

      const { data, message } = response;

      // Store lobby data correctly - extract code and _id separately
      setLobbyCode(data.code); // Store just the code like 'masors'

      // Store original game name for display purposes
      const originalGameName = gameId;

      // Store the full lobby data object (containing both code and _id)
      setRoomId(data);
      setLobbyData(data);
      setShowShareInvite(true);

      const userID = userContextData.user._id;

      // CRITICAL: We need to use _id for the game ID expected by the API
      // Log the exact data we need for constructing URLs
      const gameParams = {
        gameId: _id, // Use the MongoDB ID of the game
        playerId: userID,
        lobbyId: data._id,
        lobbyCode: data.code,
        gameName:
          originalGameName.charAt(0).toUpperCase() + originalGameName.slice(1),
      };


      // Navigate to waiting room with full parameters
      // navigateTo(`/games/waiting-room/${data._id}/${data.code}?actualGameId=${_id}&gameName=${originalGameName.charAt(0).toUpperCase() + originalGameName.slice(1)}&stakeAmount=${value * 100}`);

      socket.emit("lobby-created", userID);

      setApiReqs({ isLoading: false, errorMsg: null });
    } catch (error) {
      // console.error(error);
      setApiReqs({
        isLoading: false,
        errorMsg: error.message ? error.message : "Error getting users",
      });
    }
  };

  const openStakes = () => setShowStakes(true);
  const hideStakes = () => setShowStakes(false);

  const openActiveUsers = (amountStaked) => {
    setShowActiveUsers(true);
    setStakeValue(amountStaked);
  };
  const hideActiveUsers = () => setShowActiveUsers(false);

  const openActivePlayers = (amountStaked) => {
    setShowActivePlayers(true);
    setStakeValue(amountStaked);
  };

  const hideActivePlayers = () => {
    setShowActivePlayers(false);
  };

  // const onIncrementStake = () => stakeValue < 25000 && setStakeValue(prev => prev + 1000)
  // const onDecrementStake = () => stakeValue > 0 && setStakeValue(prev => prev - 1000)
  // const resetStakeValue = amount => setStakeValue(amount)

  const openJoinLobbyModal = () =>
    setJoinLobbyModal({
      visible: true,
      onHide: hideJoinLobbyModal,
      size: "md",
    });
  const hideJoinLobbyModal = () =>
    setJoinLobbyModal({ visible: false, onHide: null, size: "md" });

  const goToGame = () => navigateTo(`/games/${gameId}?roomID=${roomId.code}`);

  const onSelectUser = (user) => {
    // Extract opponent ID from any available property
    const opponentId =
      user.opponentId || user.user_id || user._id || user.id || user.userId;
    const opponentAvatar =
      user.avatar || user.profile || user.avatarUrl || user.userAvatar;
    const opponentName =
      user.username || user.name || user.userName || user.userId || user.id;
   

    if (roomId && opponentId && gameId) {
      // Get the current player ID
      const playerId = userContextData?.user?._id;

      // Get lobby information
      const lobbyCode = roomId.code;

      // Ensure we get the correct lobby ID format
      const lobbyId = roomId._id;

      // Format game name properly (capitalize first letter)
      const formattedGameName =
        gameId.charAt(0).toUpperCase() + gameId.slice(1);

      // CRITICAL: We need to get the actual MongoDB ID for the game
      // Find the selected game to get its _id
      const selectedGameObj = games?.filter((game) => game.id === gameId)[0];
      const actualGameId = selectedGameObj ? selectedGameObj._id : gameId;

      // Calculate stake amount (use value * 100 as in other places in the code)
      const stakeAmount = value * 100;

      // Create a complete game data object matching the mobile implementation
      const gameData = {
        gameId: actualGameId,
        playerId: playerId,
        opponentId: opponentId,
        gameName: formattedGameName,
        lobbyId: lobbyId,
        lobbyCode: lobbyCode,
        stakeAmount: stakeAmount,
      };
      navigate(
        `/games/selected-user/${gameId}/${playerId}/${opponentId}/${opponentName}/${lobbyId}/${lobbyCode}/${gameName}?avatar=${encodeURIComponent(
          opponentAvatar
        )}`
      );

      return;
    }

    // Fallback to original game navigation
    goToGame();

    setApiReqs({
      isLoading: false,
      data: null,
      errorMsg: "Something went wrong! Try again later",
    });
  };

  // Handler for ShareInvite actions
  const handleShare = () => {
    if (lobbyData) {
      navigator.clipboard.writeText(lobbyData.code);
      alert("Code copied!");
    }
  };

  const handleJoin = () => {
    // Find the selected game to get its _id before opening active users
    const selectedGameObj = games?.filter((game) => game.id === gameId)[0];
    const actualGameId = selectedGameObj ? selectedGameObj._id : gameId;
    const gameName = gameId;

    // Navigate to the waiting room with all necessary parameters
    navigateTo(
      `/games/waiting-room/${lobbyData._id}/${lobbyData.code}?actualGameId=${actualGameId}&gameName=${gameName}`
    );
  };
  const handlePlayRandom = () => {
    setShowShareInvite(false);
    openActiveUsers(value * 100); // Or implement random user logic if different
  };

  const handlePlayActiveUsers = () => {
    setShowShareInvite(false);
    openActivePlayers(value * 100);
  };

  const handleShowJoinGame = () => setShowJoinGame(true);

  if (showJoinGame) {
    const selectedGameObj = games?.filter((game) => game.id === gameId)[0];
    const actualGameId = selectedGameObj ? selectedGameObj._id : gameId;
    return (
      <JoinGame
        onBack={() => setShowJoinGame(false)}
        qrValue={lobbyData} // Pass the full lobby data object
        gameId={actualGameId}
        gameName={gameId.charAt(0).toUpperCase() + gameId.slice(1)}
      />
    );
  }
  const gameName = gameId;

  if (showShareInvite && lobbyData) {
    // Find the selected game to get its _id
    const selectedGameObj = games?.filter((game) => game.id === gameId)[0];
    const actualGameId = selectedGameObj ? selectedGameObj._id : gameId;

    return (
      <ShareInvite
      code={lobbyData.code}
      qrValue={lobbyData} // Pass the full lobby data object
      gameId={actualGameId} // Use the actual MongoDB ID
      onShare={handleShare}
      onJoin={handleJoin}
      onPlayRandom={handlePlayRandom}
      onPlayActiveUsers={handlePlayActiveUsers}
      gameName={gameId.charAt(0).toUpperCase() + gameId.slice(1)}
      onClose={() => setShowShareInvite(false)}
      />
    );
  }

  if (selectedGame) {
    const { id, bgClass, img, title, caption, text, splitTitle1, splitTitle2 } =
      selectedGame;

    if (isMobile) {
      // Show Active Users if requested
      if (showActiveUsers) {
        return (
          <div className="h-full w-full flex flex-col bg-[#130828]">
            {/* Header */}
            <div className="flex items-center px-4 py-3 border-b border-white/10">
              <button
                onClick={() => {
                  setShowActiveUsers(false);
                  setShowShareInvite(true);
                }}
                className="text-white mr-3"
              >
                <IoArrowBackSharp size={24} color="#fff" />
              </button>
              <span className="text-[#6FCF97] font-bold space-y-3 text-lg">
                Select Player
              </span>
            </div>
            {/* ActiveUsers Component */}
            <ActiveUsers
              btnTxt="select"
              btnFunc={onSelectUser}
              gameId={gameId}
              qrValue={lobbyData}
              lobbyCode={lobbyData?.code}
              gameName={gameName}
              currentPlayerId={userContextData?.user?._id}
            />
          </div>
        );
      }

      if (showActivePlayers) {
      
        return (
            <div className="h-full w-full flex flex-col bg-[#130828]">
            <div className="flex items-center px-4 py-3 border-b border-white/10">
              <button
                onClick={() => {
                  setShowActiveUsers(false);
                  setShowShareInvite(true);
                }}
                className="text-white mr-3"
              >
                <IoArrowBackSharp size={24} color="#fff" />
              </button>
              <span className="text-[#6FCF97] font-bold space-y-3 text-lg">
                Select Player
              </span>
            </div>
          <ActivePlayers
            btnTxt="select"
            btnFunc={onSelectUser}
            gameId={gameId}
            qrValue={lobbyData}
            lobbyCode={lobbyData?.code}
            gameName={gameName}
            currentPlayerId={userContextData?.user?._id}
          />
          </div>
        );
      }

      // If loading the game, show loading state
      if (loadingGame) {
        return <div>Loading game...</div>;
      }

      return (
        <div className="w-full p-4 bg-[#130828] text-white min-h-screen flex flex-col items-center">
          {/* Header */}
          <div className="w-full flex items-center mb-4">
            <button onClick={() => navigate(-1)} className="mr-4">
              <IoArrowBackSharp size={24} className="text-white" />
            </button>
            <span className="text-yellow-500 font-bold text-lg">{title}</span>
          </div>

          {/* Game Image */}
          <img
            src={img}
            alt={title}
            className="w-full max-h-60 object-cover rounded-lg mb-4"
          />
          <p className="text-sm text-center text-gray-200 mb-6 px-2">{text}</p>

          {/* Buttons */}
          <button
            className="w-full border border-yellow text-white font-semibold py-2 rounded mb-3 transition"
            onClick={openStakes}
          >
            CREATE LOBBY
          </button>
          <button
            className="w-full  bg-yellow-500 text-black  hover:bg-yellow-600  font-semibold py-2 rounded transition"
            onClick={handleShowJoinGame}
          >
            JOIN LOBBY
          </button>

          {/* Stake Selection Modal */}
          <CSSTransition
            in={showStakes}
            timeout={300}
            classNames="alert"
            unmountOnExit
            nodeRef={stakesNodeRef}
            onEnter={() => setShowBtns && setShowBtns(false)}
            onExited={() => setShowBtns && setShowBtns(true)}
          >
            <div ref={stakesNodeRef} className="w-full mt-6">
              <p className="mb-4 text-white text-sm font-light font-poppins">
                Risk Coin
              </p>

              <AmountPicker
                btnTxt="Confirm Amount"
                btnFunc={initiateLobbyCreation}
                subTxt="Risk 100 coins upwards for a 2 player game"
                value={value}
                loading={apiReqs.isLoading}
                setValue={setValue}
                className="mx-auto w-full max-w-md"
              />

              <button
                onClick={hideStakes}
                className="w-full flex items-center justify-center py-2 mt-6 border border-white rounded hover:bg-white hover:text-black transition"
              >
                <span className="text-sm font-medium font-poppins">Hide</span>
              </button>
            </div>
          </CSSTransition>

          {/* Join Lobby Modal */}
          <JoinLobbyModal modalProps={joinLobbyModal} />
        </div>
      );
    }
    if (showActiveUsers && !isMobile) {
      return (
        <div className="">
          <div className="">
            <button onClick={hideActiveUsers} className="px-3 py-2 bg-yellow-500">
              <IoArrowBackSharp size={24} color="#ffffff" />
            </button>
            <span className=" text-black font-bold space-y-3 text-lg">
              Confirm Amount
            </span>
          </div>
          <ActiveUsers
            btnTxt="select"
            btnFunc={onSelectUser}
            gameId={gameId}
            qrValue={lobbyData}
            lobbyCode={lobbyData?.code}
            gameName={gameName}
            currentPlayerId={userContextData?.user?._id}
          />
        </div>
      );
    }

    if (showActivePlayers && !isMobile) {
      return (
        <ActivePlayers
          btnTxt="select"
          btnFunc={onSelectUser}
          gameId={gameId}
          qrValue={roomId}
          lobbyCode={roomId?.code}
          gameName={gameName}
          currentPlayerId={userContextData?.user?._id}
        />
      );
    }

    return (
      <div style={{ minHeight: "100vh" }} className="dashboard">
        <DashboardHeader />
        <div className="d-lg-flex d-md-flex d-block mt-lg-4 mt-md-4 mt-4 px-lg-4 px-md-4 px-4 justify-content-between align-items-start herogeneral">
          <div className="d-lg-none d-md-none d-flex align-items-center justify-content-between mb-2">
            <div className="col-lg-2">
              <CollapseBlock isSmallScreen={true} />
            </div>
            <div className="col-lg-2">
              <CollapseBlockRight isSmallScreen={true} />
            </div>
          </div>

          <div
            className={`${
              isLeftBlockOpen ? "col-lg-2 col-md-2" : "col-lg-1 col-md-1"
            } d-lg-flex d-md-flex d-none`}
          >
            <CollapseBlock setIsLeftBlockOpen={setIsLeftBlockOpen} />
          </div>

          <div
            className={`${
              blocksOpen === "both"
                ? "col-lg-8 col-md-8"
                : blocksOpen === "one"
                ? "col-lg-9 col-md-9"
                : blocksOpen === "none"
                ? "col-lg-10 col-md-10"
                : ""
            } col-auto px-lg-4 px-md-4 px-0`}
          >
            <div>
              {showGames && (
                <div className="d-flex align-items-center justify-content-stretch">
                  <div className="w-100">
                    <div className="d-flex align-items-center justify-content-center create-lobby-bg col-lg-12 col-md-12 col-12 mb-3">
                      <img
                        src={img}
                        className="col-lg-12 col-md-12 col-12"
                        alt=""
                      />
                    </div>

                    <h1 className="m-0 p-0 mb-3 font-weight-700 font-family-quantico txt-large txt-FFF">
                      {splitTitle1}{" "}
                      <span className="create-lobby-title-span">
                        {splitTitle2}
                      </span>
                    </h1>

                    {showBtns && (
                      <div>
                        <p className="m-0 p-0 mb-4 regular-txt font-weight-300 font-family-poppins txt-FFF opacity-_7">
                          {text}
                        </p>

                        <button
                          onClick={openStakes}
                          className="w-100 bg-FBBC04 d-flex align-items-center justify-content-center p-2 mb-3"
                        >
                          <p className="p-0 m-0 small-txt txt-000 font-weight-500 font-family-poppins mx-1">
                            Create Lobby
                          </p>
                          <div className="m-0 p-0 mx-2 d-flex align-items-center">
                            <CustomSvg name={"arrow-right"} color="#000" />
                          </div>
                        </button>

                        <button
                          onClick={handleShowJoinGame}
                          className="w-100 bg-transparent create-lobby-join-btn d-flex align-items-center justify-content-center p-2 mb-5"
                        >
                          <p className="p-0 m-0 small-txt txt-FFF font-weight-500 font-family-poppins mx-1">
                            Join Lobby
                          </p>
                          <div className="m-0 p-0 mx-2 d-flex align-items-center">
                            <CustomSvg name={"arrow-right"} />
                          </div>
                        </button>
                      </div>
                    )}

                    <CSSTransition
                      in={showStakes}
                      timeout={300}
                      classNames="alert"
                      unmountOnExit
                      nodeRef={stakesNodeRef}
                      onEnter={() => setShowBtns(false)}
                      onExited={() => setShowBtns(true)}
                    >
                      <div ref={stakesNodeRef} className="w-100">
                        <p className="m-0 p-0 mb-4 regular-txt font-weight-300 font-family-poppins txt-FFF">
                          Select Stake Amount
                        </p>

                        {apiReqs.errorMsg && (
                          <CustomErrorMsg
                            errorMsg={apiReqs.errorMsg}
                            verticalPadding={true}
                          />
                        )}

                        <AmountPicker
                          btnTxt="Select Player"
                          btnFunc={initiateLobbyCreation}
                          subTxt="Stake 100 upwards for a 2 player game"
                          value={value}
                          loading={apiReqs.isLoading}
                          setValue={setValue}
                        />

                        <button
                          onClick={hideStakes}
                          className="w-100 bg-transparent create-lobby-join-btn d-flex align-items-center justify-content-center p-2 mb-5"
                        >
                          <div className="m-0 p-0 mx-1 d-flex align-items-center">
                            <IoArrowBackSharp size={20} color="#fff" />
                          </div>
                          <p className="p-0 m-0 small-txt txt-FFF font-weight-500 font-family-poppins mx-1">
                            Back
                          </p>
                        </button>
                      </div>
                    </CSSTransition>
                  </div>
                </div>
              )}

              {showActiveUsers && (
                <div className="w-100" ref={showActiveUsersNodeRef}>
                  <button
                    onClick={hideActiveUsers}
                    className="w-25 bg-transparent create-lobby-join-btn d-flex align-items-center justify-content-center p-2 mb-4"
                  >
                    <div className="m-0 p-0 mx-1 d-flex align-items-center">
                      <IoArrowBackSharp size={20} color="#fff" />
                    </div>
                    <p className="p-0 m-0 small-txt txt-FFF font-weight-500 font-family-poppins mx-1">
                      Back
                    </p>
                  </button>
                  <ActiveUsers
                    btnTxt="select"
                    btnFunc={onSelectUser}
                    gameId={gameId}
                    qrValue={roomId} // Pass the full roomId object to extract _id
                    lobbyCode={roomId?.code}
                    gameName={gameName}
                    currentPlayerId={userContextData?.user?._id}
                  />
                </div>
              )}

              {showActivePlayers && (
                <div className="w-100" ref={showActivePlayersNodeRef}>
                  <button
                    onClick={hideActivePlayers}
                    className="w-25 bg-transparent create-lobby-join-btn d-flex align-items-center justify-content-center p-2 mb-4"
                  >
                    <div className="m-0 p-0 mx-1 d-flex align-items-center">
                      <IoArrowBackSharp size={20} color="#fff" />
                    </div>
                    <p className="p-0 m-0 small-txt txt-FFF font-weight-500 font-family-poppins mx-1">
                      Back
                    </p>
                  </button>
                  <ActivePlayers
                    btnTxt="select"
                    btnFunc={onSelectUser}
                    gameId={gameId}
                    qrValue={roomId} // Pass the full roomId object to extract _id
                    lobbyCode={roomId?.code}
                    gameName={gameName}
                    currentPlayerId={userContextData?.user?._id}
                  />
                </div>
              )}
            </div>
          </div>

          <div
            className={`${
              isRightBlockOpen ? "col-lg-2 col-md-2" : "col-lg-1 col-md-1"
            } d-lg-flex d-md-flex d-none align-items-center justify-content-end`}
          >
            <div className="">
              <CollapseBlockRight setIsRightBlockOpen={setIsRightBlockOpen} />
            </div>
          </div>
        </div>

        <JoinLobbyModal modalProps={joinLobbyModal} />
      </div>
    );
  } else {
    return navigateTo("/");
  }
}

